import { Box } from '@eatclubcode/ec-component-library';
import { API } from 'aws-amplify';
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';
import { obeeSettings } from '../data/graphql/queries';
import Error from '../screens/Error/Error';
import { getAppVersion, isEmpty } from '../utils/helpers';
import routes from './Routes';

// Routes
import NotFound from '../screens/NotFound/NotFound';

/**
 * TODO replace with new browser router
 * https://reactrouter.com/en/main/routers/create-browser-router
 *
 * @param activeRestaurant
 * @returns {JSX.Element}
 * @constructor
 */
const SwitchRoutes = ({ activeRestaurant }) => {
  const premium = activeRestaurant?.premium;

  return (
    <Switch>
      {routes.map((route) => {
        if (!premium) {
          return (
            <Route key={route.path} exact={route.exact} path={route.path}>
              <route.premiumRequired />
            </Route>
          );
        }

        // if (route.path === '/' && premium) {
        //   return (
        //     <Route key={route.path} exact={route.exact} path={route.path}>
        //       <Redirect to='/runsheet' />
        //     </Route>
        //   );
        // }

        if (route.path === '/obeeLogin') {
          return (
            <Route key={route.path} exact={route.exact} path={route.path}>
              <Box>Logging in...</Box>
            </Route>
          );
        }

        if (!route.noRestaurantNeeded && isEmpty(activeRestaurant)) {
          return (
            <Route path='*'>
              <Error />
            </Route>
          );
        }

        return (
          <Route key={route.path} exact={route.exact} path={route.path}>
            <route.main />
          </Route>
        );
      })}

      {/* Route doesnt exist in Routes */}
      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  );
};

SwitchRoutes.defaultProps = {
  activeRestaurant: null,
};

SwitchRoutes.propTypes = {
  activeRestaurant: PropTypes.shape({
    premium: PropTypes.bool,
  }),
};

export default SwitchRoutes;
